export const encodeParams = p =>
  Object.entries(p).filter(([, value]) => (value !== null) && (value !== undefined)).map(([key, value]) => (value?.constructor === Array ? value.map(elem => [key + '[]', elem].map(encodeURIComponent).join('=')).join('&') : [key, value].map(encodeURIComponent).join('='))).join('&')

export const paramsToQuery = p =>
  `${p && Object.keys(p).length ? '?' + encodeParams(p) : ''}`

export const cycleListTag = cycleId => `cycle-${cycleId}`
